import { UserProjectStatus } from '@teachur/http-client';
import ApiService from './apiService';
import { PaginatedResponse, PaginationParams } from './types';

export type GetUserProjectsOptions = PaginationParams & {
  courseId?: number;
  projectId?: number;
  status?: UserProjectStatus;
  userId?: number;
};

export const UserProjectService = {
  getAll: async (options: GetUserProjectsOptions) => {
    const response = await ApiService.get<PaginatedResponse<UserProject>>(
      '/user-projects',
      options
    );
    return response.data;
  },
  create: async (projectId: number, file: ApiFile) => {
    const response = await ApiService.post<UserProject>(`/user-projects`, {
      projectId,
      file,
    });
    return response.data;
  },
  update: async (id: number, data: { status: UserProjectStatus }) => {
    const response = await ApiService.put<UserProject>(`/user-projects/${id}`, data);
    return response.data;
  },
  delete: async (userProjectId: number) => {
    const response = await ApiService.delete(`/user-projects/${userProjectId}`);
    return response.data;
  },
  claimUserProject: async (userProjectId: number, instructorId?: number) => {
    const response = await ApiService.post<UserProject>(`/user-projects/${userProjectId}/claim`, {
      instructorId,
    });
    return response.data;
  },
  disclaimUserProject: async (userProjectId: number) => {
    const response = await ApiService.post<UserProject>(
      `/user-projects/${userProjectId}/disclaim`,
      {}
    );
    return response.data;
  },
};
